// Utilitaires pour envoyer des événements de feedback (toasts et modales) sans avoir besoin d'un React Context
export const toast = {
  success: (msg, duration = 2000) => document.dispatchEvent(new CustomEvent('app-toast', { detail: { msg, type: 'success', duration } })),
  error: (msg, duration = 3000) => document.dispatchEvent(new CustomEvent('app-toast', { detail: { msg, type: 'error', duration } })),
  info: (msg, duration = 3000) => document.dispatchEvent(new CustomEvent('app-toast', { detail: { msg, type: 'info', duration } }))
};

export const confirmDialog = (msg, onConfirm) => {
  document.dispatchEvent(new CustomEvent('app-confirm', { detail: { msg, onConfirm } }));
};
